module.exports = __webpack_public_path__ + "img/paste.1fca93a9.svg";